import React, { useEffect } from 'react';
import './css/App.css';
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Home, Bingo, Love, Invitation, McQueen, Attendance, Bus, BusAdmin } from './routes';

function App() {
  useEffect(() => {
    // check if userToken exists, if not generate one
    const token = localStorage.getItem('userToken');
    if (!token || token.length < 16) {
      const token = generateToken();
      localStorage.setItem('userToken', token);
    }

    // if # in url scroll to element with id
    const hash = window.location.hash;
    const element = document.getElementById(hash.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const generateToken = () => {
    return Math.random().toString(36).substr(2, 16); // 16 caracteres alfanuméricos
  };

  return (
    <HelmetProvider>
      <Router>
        <Switch>
          <Route path="/love" component={Love} />
          <Route path="/mcqueen" component={McQueen} />
          <Route path="/bingo" component={Bingo} />

          <Route path="/invitacion" component={Invitation} />

          <Route path="/bus/admin" component={BusAdmin} />
          <Route path="/bus" component={Bus} />

          <Route path="/supersecretsection/asistencia" component={Attendance} />

          <Route path="/" component={Home} />
        </Switch>
      </Router>
    </HelmetProvider>
  );
}

export default App;
